module.exports = __webpack_public_path__ + "static/media/outer_27.3768e5aa.jpg";